import { render, staticRenderFns } from "./SecondRow.vue?vue&type=template&id=656ef376&scoped=true"
import script from "./SecondRow.vue?vue&type=script&lang=js"
export * from "./SecondRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656ef376",
  null
  
)

export default component.exports